import { Color, Spacing } from '@persona-id/design-tokens';
import { noop } from 'lodash/fp';
import { FormProvider } from 'react-hook-form';
import styled from 'styled-components';

import { TriggerAccount } from 'dashboard/models/trigger';
import FormAccountAction from 'dashboard/views/DashboardAccountsShowView/components/FormAccountAction';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';
import { Heading } from 'design-system/components/Text';
import { useFormSecurely } from 'lib/security/reactHookForm';

const PreviewHeader = styled.div`
  margin: 0;
  padding-bottom: ${Spacing[5]};
`;

const PreviewContainer = styled.div`
  padding: 0px 10%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const PreviewBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
`;

const StyledSticker = styled(Sticker)`
  width: fit-content;
  border: 1px solid ${Color.CorePurple200};
`;

interface TriggerAccountInputModalPreviewProps {
  trigger: TriggerAccount;
  workflowName: string;
}

const TriggerAccountInputModalPreview = ({
  trigger,
  workflowName,
}: TriggerAccountInputModalPreviewProps) => {
  const accountActionFormContext = useFormSecurely({
    mode: 'onChange',
    defaultValues: {},
  });

  const isSchemaEmpty = trigger.attributes['input-modal-configuration'].length === 0;

  return (
    <PreviewContainer>
      <StyledSticker variant='primary'>Preview</StyledSticker>
      <Spacer height={2} />
      {isSchemaEmpty ? (
        <>
          <h3>Looks like there aren&#39;t any input fields yet.</h3>
          <p>Create an input field to get started.</p>
        </>
      ) : (
        <PreviewBodyContainer>
          <PreviewHeader>
            <Heading size='md'>{workflowName}</Heading>
          </PreviewHeader>
          <FormProvider {...accountActionFormContext}>
            <FormAccountAction
              trigger={trigger}
              accountDataContext={{}}
              /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
              handleRunAction={() => Promise.resolve(null)}
              handleCancel={noop}
            />
          </FormProvider>
        </PreviewBodyContainer>
      )}
    </PreviewContainer>
  );
};

export default TriggerAccountInputModalPreview;
